import React, { useState } from "react";

// ── Nav ──────────────────────────────────────────────────────────────────────
const NAV_ITEMS = [
  { id: "auth",        label: "Authentication",      color: "#5F5E5A", section: "Overview" },
  { id: "get_operator",label: "Fetch Recharge Operator", color: "#185FA5", section: "Recharge API" },
  { id: "dth_operator",label: "Fetch DTH Operator",   color: "#185FA5", section: null },
  { id: "get_circle",  label: "Fetch Recharge Circle",color: "#185FA5", section: null },
  { id: "create_mobile", label: "Create Mobile Recharge", color: "#3B6D11", section: null },
  { id: "create_dth",  label: "Create DTH Recharge",  color: "#3B6D11", section: null },
  { id: "recharge_status", label: "Recharge Status Check", color: "#BA7517", section: null },
  { id: "recharge_callback", label: "Recharge Callback", color: "#D85A30", section: null },
  { id: "bbps_operator", label: "Fetch BBPS Operator", color: "#185FA5", section: "BBPS" },
  { id: "bbps_status", label: "BBPS Status Check",     color: "#BA7517", section: null },
  { id: "bbps_bill",   label: "Fetch Biller Info",     color: "#534AB7", section: null },
  { id: "bbps_pay",    label: "Pay BBPS Bill Online",  color: "#3B6D11", section: null },
  { id: "bbps_pay_manual", label: "Pay BBPS Bill Offline", color: "#3B6D11", section: null },
  { id: "balance",     label: "Fetch API Balance",     color: "#534AB7", section: "Account" },

  // ── UPI ──────────────────────────────────────────────────────────────────
  // { id: "upi_create_order", label: "Create Wallet Top-up Order", color: "#185FA5", section: "UPI" },
  { id: "upi_status",       label: "UPI Status Check",           color: "#BA7517", section: null },
  { id: "upi_callback",     label: "UPI Gateway Callback",       color: "#D85A30", section: null },
  { id: "upi_qr_pay",       label: "Pay UPI QR",        color: "#3B6D11", section: null },

  // ── OTT Subscription ──────────────────────────────────────────────────────
  { id: "ott_operators",    label: "Get OTT Operators",          color: "#185FA5", section: "OTT Subscription" },
  { id: "ott_plans",        label: "Fetch OTT Plans",            color: "#534AB7", section: null },
  { id: "ott_subscribe",    label: "Create OTT Subscription",    color: "#3B6D11", section: null },
  { id: "ott_status",       label: "OTT Status Check",           color: "#BA7517", section: null },
  { id: "ott_callback",     label: "OTT Webhook Callback",       color: "#D85A30", section: null },
];

// ── Shared styles ───────────────────────────────────────────────────────────
const styles = {
  methodBadge: (method) => ({
    display: "inline-block", padding: "3px 9px", borderRadius: 6,
    fontSize: 11, fontWeight: 600, fontFamily: "monospace",
    background: method === "POST" ? "#EAF3DE" : "#E6F1FB",
    color: method === "POST" ? "#3B6D11" : "#0C447C",
  }),
  badge: (type) => ({
    display: "inline-block", padding: "1px 7px", borderRadius: 4,
    fontSize: 10, fontWeight: 600,
    background: type === "required" ? "#FCEBEB" : "#F1EFE8",
    color: type === "required" ? "#A32D2D" : "#5F5E5A",
  }),
  codeBlock: {
    background: "#F8FAFC", border: "0.5px solid #e2e8f0", borderRadius: 8,
    padding: "14px 16px", fontFamily: "monospace", fontSize: 12,
    lineHeight: 1.8, overflowX: "auto", position: "relative", whiteSpace: "pre",
  },
  table: { width: "100%", borderCollapse: "collapse", fontSize: 12 },
  th: {
    padding: "8px 10px", textAlign: "left", background: "#f8fafc",
    color: "#64748b", fontWeight: 600, fontSize: 11, borderBottom: "0.5px solid #e2e8f0",
  },
  td: { padding: "9px 10px", borderBottom: "0.5px solid #f1f5f9", verticalAlign: "top" },
  noteBox: (color = "#BA7517") => ({
    background: color === "#BA7517" ? "#FAEEDA" : color === "#185FA5" ? "#E6F1FB" : "#FCEBEB",
    borderLeft: `3px solid ${color}`, padding: "10px 14px", fontSize: 12,
    color: color === "#BA7517" ? "#633806" : color === "#185FA5" ? "#0C447C" : "#A32D2D",
    marginBottom: 16,
  }),
};

function CopyButton({ getText }) {
  const [copied, setCopied] = useState(false);
  const copy = () => {
    navigator.clipboard.writeText(getText()).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };
  return (
    <button onClick={copy} style={{
      position: "absolute", top: 8, right: 8, padding: "3px 10px", background: "#fff",
      border: "0.5px solid #e2e8f0", borderRadius: 6, fontSize: 11, cursor: "pointer", color: "#64748b",
    }}>
      {copied ? "Copied!" : "Copy"}
    </button>
  );
}

function CodeBlock({ code }) {
  return (
    <div style={styles.codeBlock}>
      <CopyButton getText={() => code} />
      <div>{code}</div>
    </div>
  );
}

function SectionLabel({ children, style = {} }) {
  return (
    <div style={{
      fontSize: 11, fontWeight: 600, color: "#64748b", letterSpacing: ".06em",
      textTransform: "uppercase", marginBottom: 10, marginTop: 20, ...style,
    }}>
      {children}
    </div>
  );
}

function BaseUrl({ method, path, query }) {
  return (
    <div style={{
      display: "inline-flex", alignItems: "center", gap: 10, background: "#f8fafc",
      border: "0.5px solid #e2e8f0", borderRadius: 8, padding: "8px 14px",
      fontFamily: "monospace", fontSize: 12, marginTop: 10,
    }}>
      <span style={styles.methodBadge(method)}>{method}</span>
      <span style={{ color: "#64748b" }}>https://pro.mokshiq.in/</span>
      <span style={{ color: "#185FA5", fontWeight: 600 }}>{path}</span>
      {query && <span style={{ color: "#94a3b8" }}>{query}</span>}
    </div>
  );
}

function ParamRow({ name, type, required, desc }) {
  return (
    <tr>
      <td style={styles.td}><span style={{ fontFamily: "monospace", fontSize: 12, color: "#185FA5" }}>{name}</span></td>
      <td style={styles.td}><span style={{ color: "#64748b" }}>{type}</span></td>
      <td style={styles.td}>
        <span style={styles.badge(required ? "required" : "optional")}>
          {required ? "required" : "optional"}
        </span>
      </td>
      <td style={{ ...styles.td, color: "#374151" }}>{desc}</td>
    </tr>
  );
}

function ParamTable({ rows }) {
  return (
    <div style={{ border: "0.5px solid #e2e8f0", borderRadius: 10, overflow: "hidden", marginBottom: 16 }}>
      <table style={styles.table}>
        <thead>
          <tr>
            <th style={styles.th}>Parameter</th>
            <th style={styles.th}>Type</th>
            <th style={styles.th}>Required</th>
            <th style={styles.th}>Description</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r, i) => <ParamRow key={i} {...r} />)}
        </tbody>
      </table>
    </div>
  );
}

// Every real endpoint requires these two headers
const HEADERS_NOTE = (
  <div style={styles.noteBox("#185FA5")}>
    Every request must include <code style={{ fontFamily: "monospace" }}>Authorization: Bearer &lt;token&gt;</code>{" "}
    and <code style={{ fontFamily: "monospace" }}>Origin: &lt;your registered client origin&gt;</code>.
  </div>
);

function EndpointHeader({ title, desc, method, path, query }) {
  return (
    <div style={{ marginBottom: 24, paddingBottom: 16, borderBottom: "0.5px solid #e2e8f0" }}>
      <h2 style={{ fontSize: 20, fontWeight: 600, marginBottom: 4, color: "#0f172a" }}>{title}</h2>
      <p style={{ fontSize: 13, color: "#64748b" }}>{desc}</p>
      <BaseUrl method={method} path={path} query={query} />
    </div>
  );
}

// ── Pages ─────────────────────────────────────────────────────────────────────

function AuthPage() {
  return (
    <div>
      <div style={{ marginBottom: 24, paddingBottom: 16, borderBottom: "0.5px solid #e2e8f0" }}>
        <h2 style={{ fontSize: 20, fontWeight: 600, marginBottom: 4, color: "#0f172a" }}>Authentication</h2>
        <p style={{ fontSize: 13, color: "#64748b" }}>
          All requests must include your Bearer token and the Origin header used when the token was issued.
        </p>
      </div>
      <SectionLabel style={{ marginTop: 0 }}>Request headers</SectionLabel>
      <div style={{ border: "0.5px solid #e2e8f0", borderRadius: 10, overflow: "hidden", marginBottom: 16 }}>
        <table style={styles.table}>
          <thead><tr><th style={styles.th}>Header</th><th style={styles.th}>Value</th><th style={styles.th}>Description</th></tr></thead>
          <tbody>
            <tr>
              <td style={styles.td}><span style={{ fontFamily: "monospace", fontSize: 12, color: "#185FA5" }}>Authorization</span></td>
              <td style={styles.td}><span style={{ fontFamily: "monospace", fontSize: 12, color: "#3B6D11" }}>Bearer &lt;token&gt;</span></td>
              <td style={styles.td}>Your JWT / API key</td>
            </tr>
            <tr>
              <td style={{ ...styles.td, borderBottom: "none" }}><span style={{ fontFamily: "monospace", fontSize: 12, color: "#185FA5" }}>Origin</span></td>
              <td style={{ ...styles.td, borderBottom: "none" }}><span style={{ fontFamily: "monospace", fontSize: 12, color: "#3B6D11" }}>API Partner Dashboard Url</span></td>
              <td style={{ ...styles.td, borderBottom: "none" }}>Must match the client_id embedded in your token</td>
            </tr>
          </tbody>
        </table>
      </div>
      <SectionLabel>Example (curl)</SectionLabel>
      <CodeBlock code={`curl --location 'https://pro.mokshiq.in/get_operator' \\
--header 'Authorization: Bearer <token>' \\
--header 'Origin: <origin>'`} />
      <div style={{ ...styles.noteBox("#D85A30"), marginTop: 16 }}>
        Keep your token secret. Never expose it in frontend code or public repositories.
      </div>
    </div>
  );
}

function GetOperatorPage() {
  return (
    <div>
      <EndpointHeader
        title="Fetch Recharge Operator"
        desc="Returns available mobile/DTH recharge operators."
        method="GET" path="get_operator"
      />
      {HEADERS_NOTE}
      <SectionLabel style={{ marginTop: 0 }}>curl</SectionLabel>
      <CodeBlock code={`curl --location 'https://pro.mokshiq.in/get_operator' \\
--header 'Authorization: {{Authorization}}' \\
--header 'Origin: {{Origin}}'`} />
    </div>
  );
}

function DthOperatorPage() {
  return (
    <div>
      <EndpointHeader
        title="Fetch DTH Operator"
        desc="Returns available DTH operators for a given type."
        method="GET" path="fetch_dth_operator" query="?type=dth"
      />
      {HEADERS_NOTE}
      <SectionLabel style={{ marginTop: 0 }}>Query parameters</SectionLabel>
      <ParamTable rows={[{ name: "type", type: "string", required: true, desc: 'Operator category, e.g. "dth"' }]} />
      <SectionLabel>curl</SectionLabel>
      <CodeBlock code={`curl --location 'https://pro.mokshiq.in/fetch_dth_operator?type=dth' \\
--header 'Authorization: {{Authorization}}' \\
--header 'Origin: {{Origin}}'`} />
    </div>
  );
}

function CircleePage() {
  return (
    <div>
      <EndpointHeader
        title="Fetch Recharge Circle"
        desc="Returns the list of telecom circles used for prepaid recharge."
        method="GET" path="get_circle"
      />
      {HEADERS_NOTE}
      <SectionLabel style={{ marginTop: 0 }}>curl</SectionLabel>
      <CodeBlock code={`curl --location 'https://pro.mokshiq.in/get_circle' \\
--header 'Authorization: {{Authorization}}' \\
--header 'Origin: {{Origin}}'`} />
    </div>
  );
}

function CreateMobileRechargePage() {
  return (
    <div>
      <EndpointHeader
        title="Create Mobile Recharge"
        desc="Initiate a mobile prepaid recharge (multipart/form-data)."
        method="POST" path="create_mobile_recharge"
      />
      {HEADERS_NOTE}
      <SectionLabel style={{ marginTop: 0 }}>Form-data parameters</SectionLabel>
      <ParamTable rows={[
        { name: "operator", type: "string", required: true, desc: 'Operator name, e.g. "Vodafone", "Airtel", "Jio"' },
        { name: "number",   type: "string", required: true, desc: "10-digit mobile number" },
        { name: "amount",   type: "string", required: true, desc: "Recharge amount in INR" },
        { name: "pin",      type: "string", required: true, desc: "Transaction PIN" },
        { name: "circle",   type: "string", required: true, desc: 'Circle name, e.g. "Delhi NCR"' },
      ]} />
      <SectionLabel>curl</SectionLabel>
      <CodeBlock code={`curl --location 'https://pro.mokshiq.in/create_mobile_recharge' \\
--header 'Authorization: {{Authorization}}' \\
--header 'Origin: {{Origin}}' \\
--form 'operator="Vodafone"' \\
--form 'number="6394856756"' \\
--form 'amount="10"' \\
--form 'pin="2242"' \\
--form 'circle="Delhi NCR"'`} />
    </div>
  );
}

function CreateDthRechargePage() {
  return (
    <div>
      <EndpointHeader
        title="Create DTH Recharge"
        desc="Initiate a DTH recharge (multipart/form-data)."
        method="POST" path="create_dth_recharge"
      />
      {HEADERS_NOTE}
      <SectionLabel style={{ marginTop: 0 }}>Form-data parameters</SectionLabel>
      <ParamTable rows={[
        { name: "operator", type: "string", required: true, desc: 'DTH operator name, e.g. "Tata Sky"' },
        { name: "number",   type: "string", required: true, desc: "DTH subscriber/customer ID" },
        { name: "amount",   type: "string", required: true, desc: "Recharge amount in INR" },
        { name: "pin",      type: "string", required: true, desc: "Transaction PIN" },
      ]} />
      <SectionLabel>curl</SectionLabel>
      <CodeBlock code={`curl --location 'https://pro.mokshiq.in/create_dth_recharge' \\
--header 'Authorization: {{Authorization}}' \\
--header 'Origin: {{Origin}}' \\
--form 'operator="Tata Sky"' \\
--form 'number="1234567890"' \\
--form 'amount="200"' \\
--form 'pin="2242"'`} />
    </div>
  );
}

function RechargeStatusPage() {
  return (
    <div>
      <EndpointHeader
        title="Recharge Status Check"
        desc="Check the current status of a submitted recharge transaction."
        method="GET" path="recharge_status_check" query="?id=rechargeid"
      />
      {HEADERS_NOTE}
      <SectionLabel style={{ marginTop: 0 }}>Query parameters</SectionLabel>
      <ParamTable rows={[{ name: "id", type: "string", required: true, desc: "The recharge report ID returned from the create call" }]} />
      <SectionLabel>curl</SectionLabel>
      <CodeBlock code={`curl --location 'https://pro.mokshiq.in/recharge_status_check?id=rechargeid' \\
--header 'Authorization: {{Authorization}}' \\
--header 'Origin: {{Origin}}'`} />
    </div>
  );
}

function RechargeCallbackPage() {
  return (
    <div>
      <EndpointHeader
        title="Recharge Callback"
        desc="Provider callback endpoint used to update recharge status asynchronously."
        method="GET" path="main_recharge_callback"
      />
      {HEADERS_NOTE}
      <SectionLabel style={{ marginTop: 0 }}>curl</SectionLabel>
      <CodeBlock code={`curl --location 'https://pro.mokshiq.in/main_recharge_callback' \\
--header 'Authorization: {{Authorization}}' \\
--header 'Origin: {{Origin}}'`} />
    </div>
  );
}

function BbpsOperatorPage() {
  return (
    <div>
      <EndpointHeader
        title="Fetch BBPS Operator"
        desc="Returns available BBPS billers."
        method="GET" path="fetch_bbps1_operator"
      />
      {HEADERS_NOTE}
      <SectionLabel style={{ marginTop: 0 }}>curl</SectionLabel>
      <CodeBlock code={`curl --location 'https://pro.mokshiq.in/fetch_bbps1_operator' \\
--header 'Authorization: {{Authorization}}' \\
--header 'Origin: {{Origin}}'`} />
    </div>
  );
}

function BbpsStatusPage() {
  return (
    <div>
      <EndpointHeader
        title="BBPS Status Check"
        desc="Check the status of a BBPS transaction."
        method="GET" path="bbps1_status_check" query="?txnid=<id>"
      />
      {HEADERS_NOTE}
      <SectionLabel style={{ marginTop: 0 }}>Query parameters</SectionLabel>
      <ParamTable rows={[{ name: "txnid", type: "string", required: true, desc: "BBPS transaction ID" }]} />
      <SectionLabel>curl</SectionLabel>
      <CodeBlock code={`curl --location 'https://pro.mokshiq.in/bbps1_status_check?txnid=<id>' \\
--header 'Authorization: {{Authorization}}' \\
--header 'Origin: {{Origin}}'`} />
    </div>
  );
}

function BbpsBillPage() {
  return (
    <div>
      <EndpointHeader
        title="Fetch Biller Info"
        desc="Fetch bill details for a customer before payment."
        method="POST" path="fetch_bbps1_bill"
      />
      {HEADERS_NOTE}
      <SectionLabel style={{ marginTop: 0 }}>Form-data parameters</SectionLabel>
      <ParamTable rows={[
        { name: "cn",   type: "string", required: true, desc: "Consumer number / account ID" },
        { name: "ad1",  type: "string", required: false, desc: "Additional data field 1 (biller-specific)" },
        { name: "ad2",  type: "string", required: false, desc: "Additional data field 2" },
        { name: "ad3",  type: "string", required: false, desc: "Additional data field 3" },
        { name: "ad4",  type: "string", required: false, desc: "Additional data field 4" },
        { name: "opid", type: "string", required: true, desc: "Operator / biller ID" },
      ]} />
      <SectionLabel>curl</SectionLabel>
      <CodeBlock code={`curl --location 'https://pro.mokshiq.in/fetch_bbps1_bill' \\
--header 'Authorization: {{Authorization}}' \\
--header 'Origin: {{Origin}}' \\
--form 'cn="<consumer_number>"' \\
--form 'ad1=""' \\
--form 'ad2=""' \\
--form 'ad3=""' \\
--form 'ad4=""' \\
--form 'opid="<operator_id>"'`} />
    </div>
  );
}

function BbpsPayPage({ manual }) {
  const path = manual ? "pay_bbps1_bill_mannual" : "pay_bbps1_bill";
  return (
    <div>
      <EndpointHeader
        title={manual ? "Pay BBPS Bill Offline" : "Pay BBPS Bill Online"}
        desc={manual
          ? "Record an offline/manual BBPS bill payment."
          : "Pay a fetched BBPS bill online."}
        method="POST" path={path}
      />
      {HEADERS_NOTE}
      <SectionLabel style={{ marginTop: 0 }}>Form-data parameters</SectionLabel>
      <ParamTable rows={[
        { name: "id",            type: "string", required: true,  desc: "Consumer number / bill ID" },
        { name: "ad1",           type: "string", required: false, desc: "Additional data field 1" },
        { name: "ad2",           type: "string", required: false, desc: "Additional data field 2" },
        { name: "ad3",           type: "string", required: false, desc: "Additional data field 3" },
        { name: "ad4",           type: "string", required: false, desc: "Additional data field 4" },
        { name: "opid",          type: "string", required: true,  desc: "Operator / biller ID" },
        { name: "amount",        type: "string", required: true,  desc: "Bill amount in INR" },
        { name: "customerName",  type: "string", required: true,  desc: "Customer name" },
        { name: "operatorName",  type: "string", required: true,  desc: "Biller / operator name" },
      ]} />
      <SectionLabel>curl</SectionLabel>
      <CodeBlock code={`curl --location 'https://pro.mokshiq.in/${path}' \\
--header 'Authorization: {{Authorization}}' \\
--header 'Origin: {{Origin}}' \\
--form 'id="<consumer_number>"' \\
--form 'ad1=""' \\
--form 'ad2=""' \\
--form 'ad3=""' \\
--form 'ad4=""' \\
--form 'opid="<operator_id>"' \\
--form 'amount="<amount>"' \\
--form 'customerName="<name>"' \\
--form 'operatorName="<operator>"'`} />
    </div>
  );
}

function BalancePage() {
  return (
    <div>
      <EndpointHeader
        title="Fetch API Balance"
        desc="Retrieve the authenticated account's wallet balance."
        method="GET" path="fetch_api_balance"
      />
      {HEADERS_NOTE}
      <SectionLabel style={{ marginTop: 0 }}>curl</SectionLabel>
      <CodeBlock code={`curl --location 'https://pro.mokshiq.in/fetch_api_balance' \\
--header 'Authorization: {{Authorization}}' \\
--header 'Origin: {{Origin}}'`} />
    </div>
  );
}

// ── UPI pages ─────────────────────────────────────────────────────────────────

function UpiCreateOrderPage() {
  return (
    <div>
      <EndpointHeader
        title="Create Wallet Top-up Order"
        desc="Creates a UPI payment order for topping up the account wallet via the UPI Gateway."
        method="POST" path="create_order_wallet_topup"
      />
      {HEADERS_NOTE}
      <SectionLabel style={{ marginTop: 0 }}>Form-data parameters</SectionLabel>
      <ParamTable rows={[
        { name: "userid", type: "string", required: true,  desc: "Account ID of the user topping up their wallet" },
        { name: "amount", type: "string", required: true,  desc: "Top-up amount in INR" },
        { name: "remark", type: "string", required: false, desc: "Optional remark attached to the order" },
      ]} />
      <SectionLabel>curl</SectionLabel>
      <CodeBlock code={`curl --location 'https://pro.mokshiq.in/create_order_wallet_topup' \\
--header 'Authorization: {{Authorization}}' \\
--header 'Origin: {{Origin}}' \\
--form 'userid="<user_id>"' \\
--form 'amount="<amount>"' \\
--form 'remark="wallet topup"'`} />
      <div style={{ ...styles.noteBox("#185FA5"), marginTop: 16 }}>
        Returns an <code style={{ fontFamily: "monospace" }}>orderId</code> in the response data. Use it with UPI Status Check to poll for completion.
      </div>
    </div>
  );
}

function UpiStatusPage() {
  return (
    <div>
      <EndpointHeader
        title="UPI Status Check"
        desc="Polls the gateway for the latest status of a wallet top-up order."
        method="POST" path="upi_status_check"
      />
      {HEADERS_NOTE}
      <SectionLabel style={{ marginTop: 0 }}>Form-data parameters</SectionLabel>
      <ParamTable rows={[
        { name: "orderid", type: "string", required: true, desc: "The order / ref ID returned from Create Wallet Top-up Order" },
      ]} />
      <SectionLabel>curl</SectionLabel>
      <CodeBlock code={`curl --location 'https://pro.mokshiq.in/upi_status_check' \\
--header 'Authorization: {{Authorization}}' \\
--header 'Origin: {{Origin}}' \\
--form 'orderid="<order_id>"'`} />
      <div style={{ ...styles.noteBox("#BA7517"), marginTop: 16 }}>
        The wallet is credited only once, even if this endpoint is called multiple times after a successful transaction.
      </div>
    </div>
  );
}

function UpiCallbackPage() {
  return (
    <div>
      <EndpointHeader
        title="UPI Gateway Callback"
        desc="Server-to-server callback invoked by the UPI gateway once a payment order settles. Not called directly by your application."
        method="POST" path="upi_icallback"
      />
      <div style={styles.noteBox("#D85A30")}>
        This endpoint is invoked by the payment gateway itself — configure it as the gateway's callback / webhook URL, it is not called by your client.
      </div>
      <SectionLabel style={{ marginTop: 0 }}>Fields sent by the gateway</SectionLabel>
      <ParamTable rows={[
        { name: "amount",          type: "string", required: true,  desc: "Settled transaction amount" },
        { name: "utr",             type: "string", required: false, desc: "Bank UTR reference number for the payment" },
        { name: "trxId",           type: "string", required: false, desc: "Gateway order reference (falls back to orderId if absent)" },
        { name: "orderId",         type: "string", required: false, desc: "Order reference, used when trxId is not present" },
        { name: "status",          type: "string", required: true,  desc: '"1" or "SUCCESS" indicates a completed payment' },
        { name: "responseMessage", type: "string", required: false, desc: "Human-readable status message from the gateway" },
      ]} />
      <SectionLabel>Example payload</SectionLabel>
      <CodeBlock code={`POST https://pro.mokshiq.in/upi_icallback
Content-Type: application/x-www-form-urlencoded

amount=99.00&utr=454525454245&trxId=ORDER_12345&status=SUCCESS&responseMessage=Transaction Successful`} />
    </div>
  );
}

function UpiQrPayPage() {
  return (
    <div>
      <EndpointHeader
        title="Pay UPI QR (Manual)"
        desc="Submits a manual UPI QR payment from the retailer's wallet to a scanned merchant VPA. Requires end-user authentication."
        method="POST" path="pay_upi_qr_manual"
      />
      {HEADERS_NOTE}
      <SectionLabel style={{ marginTop: 0 }}>Form-data parameters</SectionLabel>
      <ParamTable rows={[
        { name: "merchant_vpa",  type: "string", required: true,  desc: 'UPI VPA scanned from the QR code, e.g. "merchant@upi"' },
        { name: "merchant_name", type: "string", required: false, desc: "Merchant display name from the QR code" },
        { name: "amount",        type: "string", required: true,  desc: "Payment amount in INR (minimum 1)" },
        { name: "note",          type: "string", required: false, desc: 'Optional payment note (defaults to "UPI QR Payment")' },
      ]} />
      <SectionLabel>curl</SectionLabel>
      <CodeBlock code={`curl --location 'https://pro.mokshiq.in/pay_upi_qr_manual' \\
--header 'Authorization: {{Authorization}}' \\
--header 'Origin: {{Origin}}' \\
--form 'merchant_vpa="merchant@upi"' \\
--form 'merchant_name="Sharma Shop"' \\
--form 'amount="150"' \\
--form 'note="Payment for goods"'`} />
      <div style={{ ...styles.noteBox("#A32D2D"), marginTop: 16 }}>
        Requires an active KYC status and sufficient wallet balance. The retailer's wallet is debited when the payment is submitted.
      </div>
    </div>
  );
}

// ── OTT Subscription Pages ───────────────────────────────────────────────────

function OttOperatorsPage() {
  return (
    <div>
      <EndpointHeader
        title="Get OTT Operators"
        desc="Fetches the list of all supported OTT platforms and their provider codes."
        method="GET" path="get_ott_operators" query=" (Alias: /api/ott/operators)"
      />
      {HEADERS_NOTE}
      <SectionLabel style={{ marginTop: 0 }}>curl</SectionLabel>
      <CodeBlock code={`curl --location 'https://pro.mokshiq.in/get_ott_operators' \\
--header 'Authorization: Bearer <user_token>'`} />
      <SectionLabel>Response (200 OK)</SectionLabel>
      <CodeBlock code={`{
  "status": true,
  "message": "OTT operators retrieved successfully",
  "data": [
    { "name": "Sony Liv", "operator_code": 17, "code": "17", "service": "OTT" },
    { "name": "Zee 5", "operator_code": 18, "code": "18", "service": "OTT" },
    { "name": "Sun Nxt", "operator_code": 19, "code": "19", "service": "OTT" },
    { "name": "Eros Now", "operator_code": 20, "code": "20", "service": "OTT" },
    { "name": "Hungama Play", "operator_code": 21, "code": "21", "service": "OTT" },
    { "name": "Hungama Music", "operator_code": 22, "code": "22", "service": "OTT" },
    { "name": "Shemaroo", "operator_code": 23, "code": "23", "service": "OTT" },
    { "name": "Watcho OTT Pack", "operator_code": 168, "code": "168", "service": "OTT" }
  ]
}`} />
    </div>
  );
}

function OttPlansPage() {
  return (
    <div>
      <EndpointHeader
        title="Fetch OTT Plans"
        desc="Fetches the available subscription packages for an operator."
        method="GET" path="get_ott_plans" query="?operator_code=17 (Alias: /api/ott/plans)"
      />
      {HEADERS_NOTE}
      <SectionLabel style={{ marginTop: 0 }}>Query parameters</SectionLabel>
      <ParamTable rows={[
        { name: "operator_code", type: "integer / string", required: true, desc: "Operator code (e.g. 17 for Sony Liv)" },
      ]} />
      <SectionLabel>curl</SectionLabel>
      <CodeBlock code={`curl --location 'https://pro.mokshiq.in/get_ott_plans?operator_code=17' \\
--header 'Authorization: Bearer <user_token>'`} />
      <SectionLabel>Response (200 OK)</SectionLabel>
      <CodeBlock code={`{
  "status": true,
  "message": "success",
  "operator": "Sony Liv",
  "operator_code": 17,
  "data": [
    {
      "amount": "999",
      "duration": 365,
      "description": "Sony Liv Premium 12 Months All Devices",
      "plan_id": "999"
    },
    {
      "amount": "699",
      "duration": 180,
      "description": "Sony Liv Premium 6 Months",
      "plan_id": "699"
    }
  ]
}`} />
    </div>
  );
}

function OttSubscribePage() {
  return (
    <div>
      <EndpointHeader
        title="Create OTT Subscription"
        desc="Debits user's wallet under lock, initiates the subscription, calculates 6-tier commissions, and saves the report."
        method="POST" path="create_ott_subscription" query=" (Alias: /api/ott/subscribe)"
      />
      {HEADERS_NOTE}
      <SectionLabel style={{ marginTop: 0 }}>Form-data parameters</SectionLabel>
      <ParamTable rows={[
        { name: "mobile_no",      type: "string",  required: true,  desc: "10-digit customer mobile number" },
        { name: "operator_code",  type: "integer", required: true,  desc: "OTT operator code (e.g., 17)" },
        { name: "amount",         type: "number",  required: true,  desc: "Plan amount" },
        { name: "customer_email", type: "string",  required: true,  desc: "Customer email address for credentials/activation" },
        { name: "pin",            type: "string",  required: true,  desc: "Retailer's 4-digit Transaction MPIN" },
        { name: "plan_id",        type: "string",  required: false, desc: "Plan Identifier from plan fetch" },
        { name: "user_var1",      type: "string",  required: false, desc: "Optional reference metadata" },
      ]} />
      <SectionLabel>curl</SectionLabel>
      <CodeBlock code={`curl --location 'https://pro.mokshiq.in/create_ott_subscription' \\
--header 'Authorization: Bearer <user_token>' \\
--form 'mobile_no="9876543210"' \\
--form 'customer_email="customer@gmail.com"' \\
--form 'operator_code="17"' \\
--form 'amount="999"' \\
--form 'pin="1234"' \\
--form 'plan_id="999"'`} />
      <SectionLabel>Response (200 OK - Instant Success)</SectionLabel>
      <CodeBlock code={`{
  "status": true,
  "message": "OTT Subscription activated successfully!",
  "reference_num": "OTT9A3F10BC8D7E",
  "orderid": "da9842e1-f561-4728-827b-ac4dd2934d68",
  "optransid": "32321344",
  "amount": 999.0,
  "operator": "Sony Liv",
  "wallet_balance": 1845.20,
  "commission_earned": 14.70
}`} />
      <SectionLabel>Response (200 OK - Pending at Operator)</SectionLabel>
      <CodeBlock code={`{
  "status": true,
  "message": "Subscription is pending confirmation from operator.",
  "reference_num": "OTT9A3F10BC8D7E",
  "orderid": "da9842e1-f561-4728-827b-ac4dd2934d68",
  "order_status": "pending"
}`} />
    </div>
  );
}

function OttStatusPage() {
  return (
    <div>
      <EndpointHeader
        title="OTT Status Check"
        desc="Queries the live transaction state with provider and auto-settles pending orders."
        method="GET" path="ott_status_check" query="?partner_request_id=OTT9A3F10BC8D7E (Alias: /api/ott/status)"
      />
      {HEADERS_NOTE}
      <SectionLabel style={{ marginTop: 0 }}>Query parameters</SectionLabel>
      <ParamTable rows={[
        { name: "partner_request_id", type: "string", required: true, desc: "The reference_num returned during subscription creation (e.g. OTT9A3F10BC8D7E)" },
      ]} />
      <SectionLabel>curl</SectionLabel>
      <CodeBlock code={`curl --location 'https://pro.mokshiq.in/ott_status_check?partner_request_id=OTT9A3F10BC8D7E' \\
--header 'Authorization: Bearer <user_token>'`} />
      <SectionLabel>Response (200 OK)</SectionLabel>
      <CodeBlock code={`{
  "status": true,
  "message": "Subscription is successful",
  "order_status": "success",
  "reference_num": "OTT9A3F10BC8D7E",
  "orderid": "415e217b-8fb2-4c6e-a003-09e445079f12",
  "optransid": "32321344"
}`} />
    </div>
  );
}

function OttCallbackPage() {
  return (
    <div>
      <EndpointHeader
        title="OTT Webhook Callback"
        desc="Callback URL registered in the provider portal for async status updates."
        method="POST" path="ott_callback" query=" (Alias: /api/ott/callback)"
      />
      <div style={styles.noteBox("#D85A30")}>
        This webhook is invoked directly by the OTT service provider when an order status transitions.
      </div>
      <SectionLabel style={{ marginTop: 0 }}>Payload sent by Provider</SectionLabel>
      <CodeBlock code={`{
  "status": 1,
  "orderid": "415e217b-8fb2-4c6e-a003-09e445079f12",
  "opttranid": "32321344",
  "pid": "OTT9A3F10BC8D7E",
  "commission": 4.99
}`} />
      <SectionLabel>Response</SectionLabel>
      <CodeBlock code={`{
  "status": true,
  "message": "Callback processed: marked SUCCESS"
}`} />
    </div>
  );
}

// ── Main App ──────────────────────────────────────────────────────────────────
const PAGE_MAP = {
  auth:              <AuthPage />,
  get_operator:      <GetOperatorPage />,
  dth_operator:      <DthOperatorPage />,
  get_circle:        <CircleePage />,
  create_mobile:     <CreateMobileRechargePage />,
  create_dth:        <CreateDthRechargePage />,
  recharge_status:   <RechargeStatusPage />,
  recharge_callback: <RechargeCallbackPage />,
  bbps_operator:     <BbpsOperatorPage />,
  bbps_status:       <BbpsStatusPage />,
  bbps_bill:         <BbpsBillPage />,
  bbps_pay:          <BbpsPayPage manual={false} />,
  bbps_pay_manual:   <BbpsPayPage manual={true} />,
  balance:           <BalancePage />,

  // ── UPI ──────────────────────────────────────────────────────────────────
  upi_create_order:  <UpiCreateOrderPage />,
  upi_status:        <UpiStatusPage />,
  upi_callback:      <UpiCallbackPage />,
  upi_qr_pay:        <UpiQrPayPage />,

  // ── OTT Subscription ──────────────────────────────────────────────────────
  ott_operators:     <OttOperatorsPage />,
  ott_plans:         <OttPlansPage />,
  ott_subscribe:     <OttSubscribePage />,
  ott_status:        <OttStatusPage />,
  ott_callback:      <OttCallbackPage />,
};

export default function RechargeAPIDocs() {
  const [activePage, setActivePage] = useState("auth");

  return (
    <main>
      <div className="container-fluid">
        <div style={{ fontFamily: "'DM Sans', 'Segoe UI', sans-serif", background: "#f1f5f9", minHeight: "100vh", display: "flex", flexDirection: "column" }}>
          <link href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600&family=DM+Mono:wght@400;500&display=swap" rel="stylesheet" />

          <div style={{
            background: "#fff", borderBottom: "0.5px solid #e2e8f0",
            padding: "12px 20px", display: "flex", alignItems: "center", gap: 16,
            position: "sticky", top: 0, zIndex: 100,
          }}>
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <div style={{
                width: 32, height: 32, borderRadius: 8, background: "#185FA5",
                display: "flex", alignItems: "center", justifyContent: "center",
              }}>
                <span style={{ color: "#fff", fontSize: 14, fontWeight: 700 }}>M</span>
              </div>
              <div>
                <div style={{ fontSize: 14, fontWeight: 600, color: "#0f172a" }}>Mokshiq API</div>
                <div style={{ fontSize: 11, color: "#94a3b8" }}>pro.mokshiq.in · v1.0</div>
              </div>
            </div>
            <div style={{
              marginLeft: "auto", display: "flex", alignItems: "center", gap: 8,
              background: "#f8fafc", border: "0.5px solid #e2e8f0", borderRadius: 8,
              padding: "6px 12px", fontFamily: "monospace", fontSize: 11, color: "#64748b",
            }}>
              <span style={{ width: 7, height: 7, borderRadius: "50%", background: "#3B6D11", display: "inline-block" }} />
              https://pro.mokshiq.in
            </div>
          </div>

          <div style={{ display: "flex", flex: 1 }}>
            <div style={{
              width: 240, flexShrink: 0, background: "#fff", borderRight: "0.5px solid #e2e8f0",
              padding: "16px 0", position: "sticky", top: 57, height: "calc(100vh - 57px)", overflowY: "auto",
            }}>
              {NAV_ITEMS.map((item) => (
                <React.Fragment key={item.id}>
                  {item.section && (
                    <div style={{
                      padding: "12px 16px 4px", fontSize: 10, fontWeight: 600, letterSpacing: ".08em",
                      textTransform: "uppercase", color: "#94a3b8",
                    }}>
                      {item.section}
                    </div>
                  )}
                  <div
                    onClick={() => setActivePage(item.id)}
                    style={{
                      display: "flex", alignItems: "center", gap: 9, padding: "9px 16px", cursor: "pointer",
                      borderLeft: `2px solid ${activePage === item.id ? item.color : "transparent"}`,
                      background: activePage === item.id ? `${item.color}10` : "transparent",
                      color: activePage === item.id ? item.color : "#64748b",
                      fontWeight: activePage === item.id ? 600 : 400, fontSize: 13, transition: "all .15s",
                    }}
                  >
                    <span style={{
                      width: 7, height: 7, borderRadius: "50%", background: item.color, flexShrink: 0,
                      opacity: activePage === item.id ? 1 : 0.4,
                    }} />
                    {item.label}
                  </div>
                </React.Fragment>
              ))}
            </div>

            <div style={{ flex: 1, padding: "28px 32px", maxWidth: 860 }}>
              {PAGE_MAP[activePage]}
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}